import { useGoals } from 'features/goals';
import { useMemo } from 'react';
import { getGoalsDeadlineEvents } from 'shared/lib/full-calendar';

export const useGoalDeadlineEvents = () => {
  const goals = useGoals();

  return useMemo(() => getGoalsDeadlineEvents(goals), [goals]);
};
